import { client } from '../../../api';

const CONFIG_CODE = 'by_client_property_decision_maker';

/**
 * Recupera la lista delle configurazioni.
 * @returns {Promise}
 */
export function getConfigs() {
    return client.get('/configs');
}

/**
 * Aggiorna una configurazione.
 * @param {object} data - { data: { rules: [...] } }
 * @returns {Promise}
 */
export function updateBaseFieldsConfig(data) {
    return client.patch(`/configs/${CONFIG_CODE}`, data);
}

/**
 * Ripristina la configurazione ai valori di default.
 * @returns {Promise}
 */
export function resetBaseFieldsConfig() {
    return client.delete(`/configs/${CONFIG_CODE}`);
}
